export const FETCH_REGION_DELIVERY_INFO = 'FETCH_REGION_DELIVERY_INFO';
export const FETCH_REGION_DELIVERY_INFO_SUCCESS =
  'FETCH_REGION_DELIVERY_INFO_SUCCESS';
export const FETCH_REGION_DELIVERY_INFO_FAILURE =
  'FETCH_REGION_DELIVERY_INFO_FAILURE';
export const FETCH_USER_LATEST_DELIVERY_INFO =
  'FETCH_USER_LATEST_DELIVERY_INFO';
export const FETCH_USER_LATEST_DELIVERY_INFO_SUCCESS =
  'FETCH_USER_LATEST_DELIVERY_INFO_SUCCESS';
export const FETCH_USER_LATEST_DELIVERY_INFO_FAILURE =
  'FETCH_USER_LATEST_DELIVERY_INFO_FAILURE';
export const PAYMENTS_BUILD_PENDING = 'PAYMENTS_BUILD_PENDING';
export const PAYMENTS_BUILD_PENDING_SUCCESS = 'PAYMENTS_BUILD_PENDING_SUCCESS';
export const PAYMENTS_BUILD_PENDING_FAILURE = 'PAYMENTS_BUILD_PENDING_FAILURE';

export const fetchRegionDeliveryInfo = region => ({
  type: FETCH_REGION_DELIVERY_INFO,
  payload: {
    region,
  },
});

export const fetchRegionDeliveryInfoSuccess = data => ({
  type: FETCH_REGION_DELIVERY_INFO_SUCCESS,
  payload: {
    data,
  },
});

export const fetchRegionDeliveryInfoFailure = errorMessage => ({
  type: FETCH_REGION_DELIVERY_INFO_FAILURE,
  payload: {
    errorMessage,
  },
});

export const fetchUserLatestDeliveryInfo = () => ({
  type: FETCH_USER_LATEST_DELIVERY_INFO,
});

export const fetchUserLatestDeliveryInfoSuccess = data => ({
  type: FETCH_USER_LATEST_DELIVERY_INFO_SUCCESS,
  payload: {
    data,
  },
});
export const fetchUserLatestDeliveryInfoFailure = errorMessage => ({
  type: FETCH_USER_LATEST_DELIVERY_INFO_FAILURE,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  deliveryInfo: {},
  latestDeliveryInfo: {},
  errorMessage: '',
};

// reducers
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_REGION_DELIVERY_INFO:
      return {
        ...state,
      };
    case FETCH_REGION_DELIVERY_INFO_SUCCESS:
      return {
        ...state,
        deliveryInfo: action.payload.data,
      };
    case FETCH_REGION_DELIVERY_INFO_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      };
    case FETCH_USER_LATEST_DELIVERY_INFO:
      return {
        ...state,
      };
    case FETCH_USER_LATEST_DELIVERY_INFO_SUCCESS:
      return {
        ...state,
        latestDeliveryInfo: action.payload.data.deliveryInfo,
      };
    case FETCH_USER_LATEST_DELIVERY_INFO_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
};

export default reducer;

// selectors
export const getDeliveryInfo = state => state.deliveryInfo.deliveryInfo;
export const getUserLatestDeliveryInfo = state =>
  state.deliveryInfo.latestDeliveryInfo;



// WEBPACK FOOTER //
// ./app/redux/purchase/deliveryInfo.js